import {
  Swiper, Scrollbar, Keyboard,
} from 'swiper';

const swiperContainerClass = '.seasonal-exclusives__swiper';

function initSeasonalExclusives(container) {
  // In the editor ACF fires render_block_preview even when the preview markup
  // isn't there; Swiper silently returns an instance with no `el` in that case.
  if (!container) {
    return;
  }

  const swiper = new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    grabCursor: true,
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
    freeMode: true,
    modules: [Scrollbar, Keyboard],
    keyboard: {
      enabled: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      dragClass: 'seasonal-exclusives__scrollbar-drag',
    },
  });

  // When a link in an off-screen slide receives keyboard focus, the browser
  // scrolls the overflow:hidden container natively. Swiper doesn't see that,
  // so its translate and the absolutely positioned scrollbar go out of sync
  // (the scrollbar shifts off-canvas and looks clipped). Undo the native
  // scroll and let Swiper bring the slide into view instead.
  swiper.el.addEventListener('focusin', (event) => {
    const slide = event.target.closest('.swiper-slide');

    if (!slide) {
      return;
    }

    swiper.el.scrollLeft = 0;
    swiper.slideTo(Array.from(swiper.slides).indexOf(slide));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/seasonal-exclusives', ($block) => {
      initSeasonalExclusives($block.find(swiperContainerClass)[0]);
    });
  } else {
    initSeasonalExclusives(swiperContainerClass);
  }
});
